/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GrainproInputs */

const en_grainpro = /** @type {(inputs: GrainproInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GrainPro`)
};

const es_grainpro = /** @type {(inputs: GrainproInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GrainPro`)
};

/**
* | output |
* | --- |
* | "GrainPro" |
*
* @param {GrainproInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const grainpro = /** @type {((inputs?: GrainproInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GrainproInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_grainpro(inputs)
	return es_grainpro(inputs)
});